import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import { selectLoading, selectNews, selectNewsTypes } from './news.selectors';
import { getNews, reactOnNews, reactOnNewsSuccess } from './news.actions';
import { NewsReactionInput } from '@cpd-app/generated';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
  providedIn: 'root',
})
export class NewsFacade {
  public readonly news$ = this.store.pipe(select(selectNews));
  public readonly newsTypes$ = this.store.pipe(select(selectNewsTypes));
  public readonly loading$ = this.store.pipe(select(selectLoading));
  public readonly reactOnNewsSuccess$ = this.actions$.pipe(
    ofType(reactOnNewsSuccess)
  );

  constructor(private store: Store<AppState>, private actions$: Actions) {}

  public getNews(): void {
    this.store.dispatch(getNews());
  }
  public reactOnNews(input: NewsReactionInput): void {
    this.store.dispatch(reactOnNews({ input }));
  }
}
